
import React from 'react';
import { Tool } from '@/data/tools';
import ToolCard from './ToolCard';

interface SponsorSectionProps {
  goldSponsor?: Tool | null;
  silverSponsor?: Tool | null;
  bronzeSponsor?: Tool | null;
}

const SponsorSection = ({ goldSponsor, silverSponsor, bronzeSponsor }: SponsorSectionProps) => {
  // Only render if there's at least one sponsor
  if (!goldSponsor && !silverSponsor && !bronzeSponsor) return null;

  return (
    <div className="mb-8 space-y-4">
      <h2 className="text-2xl font-semibold mb-4">Featured Sponsors</h2>
      
      {goldSponsor && (
        <div className="bg-amber-50 border-l-4 border-amber-400 rounded-md overflow-hidden">
          <ToolCard tool={goldSponsor} />
        </div>
      )}
      
      {silverSponsor && (
        <div className="bg-gray-50 border-l-4 border-gray-300 rounded-md overflow-hidden">
          <ToolCard tool={silverSponsor} />
        </div>
      )}
      
      {bronzeSponsor && (
        <div className="bg-amber-50/50 border-l-4 border-amber-700 rounded-md overflow-hidden">
          <ToolCard tool={bronzeSponsor} />
        </div>
      )}
    </div>
  );
};

export default SponsorSection;
